import { render } from "./LiveAuctionPage.vue?vue&type=template&id=351f3e99&ts=true"
import script from "./LiveAuctionPage.vue?vue&type=script&lang=ts"
export * from "./LiveAuctionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__